// 获取url地址
// const getNewUrlArr = (parameter) => {
//     const newUrlArr = [];
//     const { url, index, params, pathnameArr } = parameter;
//     let key = null;
//     let optional = -1;

//     if (url.indexOf(':') >= 0) {
//         optional = url.indexOf('?');
//         key = url.substr(1);
//         key = optional >= 0 ? key.slice(0, -1) : key;
//         if (params && key in params && params.hasOwnProperty(key)) {
//             // 如果参数等于undefined 则会丢弃
//             if (params[key] !== undefined) {
//                 newUrlArr.push(`/${params[key]}`);
//             }
//         } else {
//             if (optional === -1 || pathnameArr[index]) {
//                 newUrlArr.push(`/${pathnameArr[index]}`);
//             }
//         }
//     } else {
//         newUrlArr.push(`/${url}`);
//     }

//     return newUrlArr;
// };

// 处理函数：多个? → 保留1个
const removeExtraQuestionMark = (str) => {
    return str.replace(/\?{2,}/g, '?');
};

// 把url 字符串转换成对象
const querystringParse = (search) => {
    search = search.substr(1);
    const searchArr = search.split('&');
    const objParameter = {};
    searchArr.forEach((target) => {
        const parameter = target.split('=');
        objParameter[parameter[0]] = parameter[1];
    });
    return objParameter;
};

// 把对象转成url参数
const queryStringify = (data) => {
    const keys = Object.keys(data);
    let formStr = '';
    if (keys.length === 0) {
        return formStr;
    }
    keys.forEach((key) => {
        if (data[key] === undefined || data[key] === null) {
            return;
        }
        formStr += `&${key}=${data[key]}`;
    });
    return formStr.substring(1);
};

// 序列化query参数
const serialize = (data) => {
    const { location } = window;
    const { search } = location;
    let formStr = '';
    if (search.length === 0) {
        formStr = queryStringify(data);
        formStr = `${formStr ? `?${formStr}` : ''}`;
    } else {
        formStr = queryStringify({
            // 不保留原来地址参数了
            // ...querystringParse(search),
            ...data,
        });
        formStr = `${formStr ? `?${formStr}` : ''}`;
    }
    // return  encodeURIComponent(formStr)
    return formStr;
};

export const getParams = ({ path, pathname }) => {
    let pathArr = path.split('/');
    let pathnameArr = pathname.split('/');
    pathArr = pathArr.filter((item) => item !== '');
    pathnameArr = pathnameArr.filter((item) => item !== '');
    const params = {};
    for (const [index, item] of pathArr.entries()) {
        if (item[0] === ':') {
            const key = item.indexOf('?') >= 0 ? item.slice(1, -1) : item.slice(1);
            params[key] = pathnameArr[index];
        }
    }
    return params;
};

/**
 * 获取URL全部GET参数，返回对象
 * @returns {object} 所有参数的键值对
 */
export const getQuery = () => {
    // 获取地址栏 ? 后面的参数
    const searchParams = new URLSearchParams(window.location.search);
    // 转换为普通对象
    return Object.fromEntries(searchParams);
};

export const pathToUrl = ({ path, pathname, params }) => {
    let pathArr = path.split('/');
    let pathnameArr = pathname.split('/');
    pathArr = pathArr.filter((item) => item !== '');
    pathnameArr = pathnameArr.filter((item) => item !== '');

    const newUrlArr = [];

    for (const [index, item] of pathArr.entries()) {
        if (item[0] === ':') {
            const key = item.indexOf('?') >= 0 ? item.slice(1, -1) : item.slice(1);

            // 要覆盖参数
            if (params && key in params && params.hasOwnProperty(key)) {
                // 如果参数等于undefined 则会丢弃
                if (params[key] !== undefined) {
                    newUrlArr.push(`/${params[key]}`);
                }
                // newUrlArr.push(`/${params[key]}`);
            } else if (pathnameArr[index] !== undefined && pathnameArr[index].trim() !== '') {
                // 没有要覆盖的参数 则使用pathname上的参数

                if (params[key] !== undefined) {
                    newUrlArr.push(`/${params[key]}`);
                }
            } else {
                // 没有要覆盖的参数 也没有pathname上的参数 则使用path上的参数

                const reg = /:([\s\S]*?)\?/g;
                // 如果包含？则是可选参数 则丢弃
                if (!item.match(reg)) {
                    newUrlArr.push(`/${item}`);
                }
            }
        } else {
            newUrlArr.push(`/${item}`);
        }
    }

    return newUrlArr.join('');
};
export const historyPush = (parameter) => {
    const {
        history = null, // 组件的props
        params = {}, // 地址传参
        query = {}, // get 传参
        isOpenWin = false, // 是否重新打开新的窗口
        // 浏览器地址 或者 pathname 路由地址
        url = '/',
        replace,
        baseUrl = '',
    } = parameter;

    const { location } = window;
    const { pathname } = location;
    // const pathnameArr = pathname.split('/');
    // let urlArr = url.split('/');
    // urlArr = urlArr.filter((item) => item !== '');
    // let newUrlArr = [];

    // for (const [index, elem] of urlArr.entries()) {
    //     if (pathnameArr[index] && pathnameArr[index].trim() !== '' && urlArr[index] && urlArr[index].trim() !== '') {
    //         newUrlArr = [
    //             ...newUrlArr,
    //             ...getNewUrlArr({
    //                 url: urlArr[index],
    //                 index,
    //                 params,
    //                 pathnameArr,
    //             }),
    //         ];
    //     } else if (elem && elem.trim() !== '') {
    //         newUrlArr = [
    //             ...newUrlArr,
    //             ...getNewUrlArr({
    //                 url: elem,
    //                 index,
    //                 params,
    //                 pathnameArr,
    //             }),
    //         ];
    //     }
    // }

    const urlArr = pathToUrl({ path: url, pathname, params });
    if (isOpenWin) {
        window.open(removeExtraQuestionMark(`${baseUrl}${urlArr}${serialize(query)}`));
    } else {
        history[replace ? 'replace' : 'push'](removeExtraQuestionMark(urlArr ? `${urlArr}${serialize(query)}` : '/'));
    }
};

export const redirectTo = (url, options = {}) => {
    const { replace = true } = options;

    historyPush({
        url,
        ...options,
        replace,
    });
};

export const openWindow = (url, options = {}) => {
    const { isOpenWin = true } = options;

    historyPush({
        url,
        ...options,
        isOpenWin,
    });
};
